export { default } from "./ObjectDetail";
